import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CsvDownloadService {

  constructor() { }

  createCSV(table: Array<any>, columns: Array<string>, headerColumns: Array<string>) {
    let csv = '';
    headerColumns.forEach(column => {
      csv = csv + column + ',';
    });
    csv = csv + '\n';
    table.forEach(item => {
      // Hacemos esto para poder acceder a propiedades anidadas.
      columns.forEach(column => {
        let obj: any;
        column.split('.').forEach(param => {
          if (obj) {
            obj = obj[param];
          } else {
            obj = item[param];
          }
        });
        csv = csv + obj + ',';
      });
      csv = csv + '\n';
    });
    return csv;
  }

  downloadFile(data: string, nombre = 'reporte.csv') {
    // Se le concatena el BOM al inicio del archivo.
    const blob = new Blob(['\ufeff' + data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = nombre;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
